export const HistoryDisplayEnum = {
    'QUESTION': 'QUESTION',
    'PARCOURSSTEP': 'PARCOURSSTEP'
};
